import {
  fetchClubJoinBannerStart,
  fetchClubJoinBannerSuccess,
  fetchClubJoinBannerFail,
  setJoinClubModalVisibility,
} from './actions'
import clubJoinBanner from './clubJoinBannerExample'

export const operationFetchClubJoinBannerStart = () => (dispatch) => {
  dispatch(fetchClubJoinBannerStart())

  setTimeout(() => {
    const response = {
      type: '200',
      data: {
        ...clubJoinBanner,
      },
    }

    if (response.type === '200') {
      dispatch(fetchClubJoinBannerSuccess(response.data))
    } else {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
      dispatch(fetchClubJoinBannerFail({}))
    }
  }, 1000)
}

export const operationSetJoinClubModalVisibility = (isVisible) => (dispatch) => {
  dispatch(setJoinClubModalVisibility(isVisible))
}

export default {
  operationFetchClubJoinBannerStart,
  operationSetJoinClubModalVisibility,
}
